import React, { useState, useEffect, useMemo } from 'react'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import ProductForm from './ProductForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { StatusPill, ActionIconButton, ListPageShell, SideDrawer, EmptyState } from '../../Components/Ui'

const Product = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [stateFilter, setStateFilter] = useState('')
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.product.get_product().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const filteredRows = useMemo(() => {
        return (rows || []).filter(r => {
            if (stateFilter === '1' && parseInt(r.state_product) !== 1) return false
            if (stateFilter === '0' && parseInt(r.state_product) === 1) return false
            return true
        })
    }, [rows, stateFilter])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.product.product_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
            setReload(true)
        })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idProduct) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idProduct } = $this.dataset

        Controllers.product.get_product_id({ p_id_product: idProduct }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idProduct}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleOpenCreate = () => {
        setModalTitle(`Registrar ${nameSingle}`)
        setDataUpdated({})
        setModalShow(true)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.product.product_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idProduct, nameProduct } = e.currentTarget.dataset
        setDataDeleted({
            p_id_product: idProduct,
            p_name_product: nameProduct
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_product', text: 'ID', align: 'center' },
                {
                    name: 'name_product', text: 'Producto', render: r => (
                        <div className="d-flex align-items-center" style={{ gap: 10, textAlign: 'left' }}>
                            <img
                                src={Helpers.config.resourcesUrl({ url: r.file_images })}
                                alt=""
                                width="40"
                                height="40"
                                style={{ borderRadius: 10, objectFit: 'cover', flexShrink: 0 }}
                                onError={e => { e.currentTarget.style.display = 'none' }}
                            />
                            <div className="sp-cell-main">
                                <strong>{r.name_product}</strong>
                                <span className="sp-cell-meta">{r.code_product} · {r.name_category}</span>
                            </div>
                        </div>
                    )
                },
                { name: 'name_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'price_product', text: 'Precio', align: 'center' },
                { name: 'state_product', text: 'Estado', align: 'center', render: r => <StatusPill tone={parseInt(r.state_product) === 1 ? 'success' : 'danger'}>
                    {parseInt(r.state_product) === 1 ? 'Activo' : 'Inactivo'}
                </StatusPill> },
                { name: 'main_product', text: 'Escritorio', align: 'center', render: r => <StatusPill tone={parseInt(r.main_product) === 1 ? 'success' : 'secondary'}>
                    {parseInt(r.main_product) === 1 ? 'Visible' : 'Oculto'}
                </StatusPill> },
                { name: 'actions', text: 'Acciones', align: 'center', render: u => {
                    return <div className="sp-row-actions">
                        <ActionIconButton tone="ghost" icon="fa fa-pen" label="Editar" data-id-product={u.id_product} onClick={handleGet} />
                        <ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-product={u.id_product} data-name-product={u.name_product} onClick={handleShowModalDelete} />
                    </div>
                } },
            ],
        ]}
        rows={filteredRows}
        isProcessing={isProcessing}
    />, [filteredRows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && filteredRows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Consulta el catálogo, filtra por estado y registra nuevos productos."
            badge="Actividad actualizada"
            primaryAction={
                <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                    Registrar {nameSingle}
                </ListPageShell.PrimaryButton>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Estado',
                    control: (
                        <select value={stateFilter} onChange={e => setStateFilter(e.target.value)}>
                            <option value="">Todos</option>
                            <option value="1">Activo</option>
                            <option value="0">Inactivo</option>
                        </select>
                    )
                },
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Producto o código…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-box"
                    title={`No hay ${namePlural.toLowerCase()}`}
                    text="Registra un producto para empezar."
                    action={
                        <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                            Registrar {nameSingle}
                        </ListPageShell.PrimaryButton>
                    }
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>

        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title={modalTitle}
            subtitle="Completa los datos del producto y guarda los cambios."
        >
            <ProductForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
        </SideDrawer>

        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_product} - {dataDeleted.p_name_product}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default Product
